module.exports = __webpack_public_path__ + "img/renesas.965f82f2.jpg";